/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Meta_TitleInputs */

const en_hub_meta_title = /** @type {(inputs: Hub_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations — Bystep`)
};

const id_hub_meta_title = /** @type {(inputs: Hub_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrasi — Bystep`)
};

/**
* | output |
* | --- |
* | "Integrations — Bystep" |
*
* @param {Hub_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_meta_title = /** @type {((inputs?: Hub_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_meta_title(inputs)
	return en_hub_meta_title(inputs)
});